import React, { FC } from 'react'
import classNames from 'classnames'
import { Text } from '@/atoms/Text'
import { NamedColor } from '@/constants/types'
import { useToggle } from '@/hooks/useToggle'

interface ExpandableDescriptionProps {
  text: string
  maxLength?: number
  className?: string
  textColor?: NamedColor
}

export const ExpandableDescription: FC<ExpandableDescriptionProps> = ({
  text,
  maxLength = 100,
  className,
  textColor = 'core-gray-400',
}) => {
  const [isExpanded, toggleIsExpanded] = useToggle(false)

  if (!text || text.length <= maxLength) {
    return (
      <Text className={classNames('photon-caption-sm lg:photon-caption-md block', className)} color={textColor}>
        {text}
      </Text>
    )
  }

  const truncatedText = isExpanded ? text : `${text.slice(0, maxLength)}...`

  return (
    <div className={className}>
      <Text className="photon-caption-sm lg:photon-caption-md block tracking-normal" color={textColor}>
        {isExpanded ? text : truncatedText}{' '}
        <span
          onClick={() => toggleIsExpanded()}
          className="!photon-caption-sm lg:!photon-caption-md inline cursor-pointer font-normal text-core-gray-400 underline hover:text-core-gray-300"
        >
          {isExpanded ? 'read less' : 'read more'}
        </span>
      </Text>
    </div>
  )
}
